<template>
  <div class="form-group">
    <textarea
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      class="form-control"
      rows="3"
      @input="$emit('input', $event.target.value)"/>
  </div>
</template>

<script>
export default {
  name: 'FormTextarea',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
